import React from "react";

export interface ISpecRowProps {
  label: string;
  caption?: string;
  align?: "start" | "center" | "stretch" | "baseline";
  inline?: boolean;
  children: React.ReactNode;
}

export const SpecRow: React.FC<ISpecRowProps> = ({
  label,
  caption,
  align = "center",
  inline = false,
  children
}: ISpecRowProps): JSX.Element => {
  const alignClass: string = `lab-spec--align-${align}`;
  const layoutClass: string = inline ? "lab-spec--inline" : "lab-spec--stack";

  return (
    <section className={`lab-spec ${alignClass} ${layoutClass}`}>
      <header className="lab-spec__head">
        <span className="lab-spec__label">{label}</span>
        {caption && <span className="lab-spec__caption">{caption}</span>}
      </header>
      <div className="lab-spec__body">{children}</div>
    </section>
  );
};
